import { Link } from "@tanstack/react-router";

import ctabg from "../assets/imgs/cta-bg.png";

const FooterCta = () => {
  return (
    <section className="footer-cta relative">
      <img src={ctabg} className="max-sm:h-48" />
      <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center  max-sm:top-6">
        <h2 className="max-sm:text-base max-md:text-2xl">Start Your Reading Journey Today</h2>
        {/* Signups disabled 2026-07-14 — was to="/sign-up" */}
        <Link
          to="/sign-in"
          className="bg-[#fcc64a] hover:bg-transparent border border-[#fcc64a] hover:text-[#fcc64a] text-white font-bold text-xl tracking-wider px-16 py-4 rounded-[20px] transition-all duration-200 ease-in-out w-fit max-sm:px-6 max-sm:py-2 max-sm:text-base max-sm:mt-0 mt-6"
        >
          Let's Learn
        </Link>
      </div>
    </section>
  );
};
export default FooterCta;
